import React, { useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useAuth } from "../context/AuthContext";
import Footer from "../components/layout/Footer";
import LoginBanner from "../assets/img/LoginBanner.png";
import LogoDormo from "../assets/img/LogoDormo.png";
import "../styles/pages/Login.css";

function Login() {
  const [user_id, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!user_id || !password) {
      toast.error('Por favor complete todos los campos');
      return;
    }

    setLoading(true);

    try {
      const result = await login({ user_id, password });
      
      if (result.success) {
        toast.success(`¡Bienvenido ${result.user.username || result.user.user_id}!`);
        // El redirect se hace automáticamente en AuthContext
      } else {
        toast.error(result.message || 'Error al iniciar sesión');
      }
    } catch (error) {
      toast.error('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="container-fluid p-0 bg-white login-content">
        <div className="row h-100 g-0">
        {/* Imagen de fondo - Solo visible en tablet y desktop */}
        <div className="col-md-6 d-none d-md-block position-relative login-image-container">
          <img
            src={LoginBanner}
            alt="Dormitorio elegante"
            className="login-banner-image"
          />
        </div>

        {/* Formulario de login */}
        <div className="col-12 col-md-6 d-flex align-items-center justify-content-center">
          <div className="login-form-container w-100">
            {/* Logo */}
            <div className="text-center mb-4">
              <img
                src={LogoDormo}
                alt="Dormo Deco Logo"
                className="logo-img mb-3"
              />
            </div>

            {/* Título de bienvenida */}
            <h2 className="text-center mb-4 fw-normal login-title">
              Bienvenido a Dormo Deco!
            </h2>

            {/* Formulario */}
            <form onSubmit={handleSubmit}>
              {/* Campo Email */}
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control py-3 px-3 login-input"
                  placeholder="Email or phone number"
                  value={user_id}
                  onChange={(e) => setUserId(e.target.value)}
                  disabled={loading}
                  required
                />
              </div>

              {/* Campo Password */}
              <div className="mb-3 position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control py-3 px-3 pe-5 login-input"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                  required
                />
                <button
                  type="button"
                  className="btn position-absolute top-50 end-0 translate-middle-y me-2 p-0 password-toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>

              {/* Opciones del formulario */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="rememberMe"
                  />
                  <label
                    className="form-check-label text-muted small"
                    htmlFor="rememberMe"
                  >
                    Remember me
                  </label>
                </div>
              </div>

              {/* Botón Sign In */}
              <button
                type="submit"
                className="btn btn-primary w-100 py-3 mb-3 signin-btn"
                disabled={loading}
              >
                {loading ? 'Iniciando sesión...' : 'Sign in'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
  );
}

export default Login;
